<div class="tw-flex a-sticker -{{ color }}" [attr.aria-labelledby]="id">
  <span [id]="id" class="a-sticker__label -size-s">
    <ng-content></ng-content>
  </span>
</div>
